import React, { FormEvent, useContext, useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  SvgIcon,
  Theme,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { SelectChangeEvent } from "@mui/material/Select/SelectInput";
import SearchIcon from "@mui/icons-material/Search";
import { useIsMount } from "./useIsMount";
import { useAuthContext } from "../../AuthContextWrapper";
import { Language } from "../../models/Langauges";

export type SearchQuery = {
  languageId?: number;
  searchTerms?: string;
};

interface Props {
  onSubmit: (query: SearchQuery) => void;
  languageId?: number;
  searchTerms?: string;
}

export const SearchAndFilter = ({
  onSubmit,
  languageId = 1,
  searchTerms = "",
}: Props): JSX.Element => {
  const isMount = useIsMount();
  const { languages } = useAuthContext()
  const [localLanguageId, setLocalLanguageId] = useState<number>(languageId);
  const [localSearchTerms, setLocalSearchTerms] = useState<string>(searchTerms);

  useEffect(() => {
    // submit upon languageId change, but not on mount
    if (!isMount) {
      submit();
    }
  }, [localLanguageId]);

  useEffect(() => {
    setLocalLanguageId(languageId);
    setLocalSearchTerms(searchTerms);
  }, [languageId, searchTerms]);

  const handleSearchSubmit = (event?: FormEvent<HTMLFormElement>): void => {
    event?.preventDefault();
    submit();
  };

  const submit = (): void => {
    onSubmit({
      languageId: localLanguageId,
      searchTerms: localSearchTerms,
    });
  };

  return (
    <form onSubmit={handleSearchSubmit}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pt: 2,
        }}
      >
        <FormControl sx={{ m: 1, display: "flex", flex: 1 }}>
          {languages && (
            <Select
              size="small"
              value={localLanguageId.toString()}
              onChange={(event: SelectChangeEvent) => {
                setLocalLanguageId(parseInt(event.target.value, 10));
              }}
              sx={{
                borderRadius: 20,
                backgroundColor: (theme: Theme) => theme.palette.common.white,
                maxWidth: 110,
              }}
            >
              {languages.map((lang: Language) => (
                <MenuItem key={lang.name} value={lang.id}>
                  {lang.name}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>

        <TextField
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SvgIcon color="action">
                  <SearchIcon />
                </SvgIcon>
              </InputAdornment>
            ),
            margin: "dense",
          }}
          placeholder="Search for a form"
          margin="normal"
          name="searchTerms"
          // onBlur={(evt: React.FocusEvent<any>) => {
          //   // trimOnBlur(evt, "text", setFieldValue, handleBlur);
          // }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setLocalSearchTerms(event.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handleSearchSubmit();
            }
          }}
          type="text"
          value={localSearchTerms}
          variant="outlined"
          sx={{
            m: 0,
            display: "flex",
            flex: 2,
            backgroundColor: (theme) => theme.palette.common.white,
          }}
        />
      </Box>
    </form>
  );
};
